export const UPLOAD_LEAVE_MESSAGE =
  '文件正在上传或尚未上传完成，离开页面将中断上传且不会保存，是否确认离开？'

export function isFileUploading(store) {
  if (!store || !store.state) return false
  const map = store.state.fileUploadingMap
  if (!map || typeof map !== 'object') return false
  return Object.keys(map).length > 0
}

export async function confirmLeaveIfFileUploading(confirmFn, store) {
  if (!isFileUploading(store) || typeof confirmFn !== 'function') return true
  try {
    await confirmFn(UPLOAD_LEAVE_MESSAGE, '提示', {
      confirmButtonText: '确定离开',
      cancelButtonText: '继续上传',
      type: 'warning'
    })
    store.commit('clearFileUploading')
    return true
  } catch (e) {
    return false
  }
}
